export const news = `
# News

</br></br>
<em>February 27, 2024</em>
</br>
### United Refining Company/Kwik Fill named to Forbes list
</br>
United Refining Company, to include Kwik Fill, has been awarded one of America’s Best Mid-Size Employers by Forbes for the year 2024. See Press Release [here](/assets/secondary/2024_forbes_press.pdf).
<hr>

<em>January 3, 2024</em>
</br>
### FOR IMMEDIATE RELEASE
</br>
Red Apple Group Announces the Promotion of John Catsimatidis Jr to President and
Chief Operating Officer
</br></br>
NEW YORK, NY Jan 3, 2024 – As part of the company’s strategic intent to further broaden the role of John A. Catsimatidis Jr, allowing him to further align his efforts with John Catsimatidis Sr, Chairman and CEO of Red Apple Group, Red Apple Group et al. today announced his promotion to President and Chief Operating Officer of the company.
</br></br>
John has been working for the company in different capacities for 12 years, serving as its Chief Investment Officer since 2020, Executive Vice President since 2017, and Vice President from 2011 to 2016. In addition to being responsible for all of Red Apple Group’s
investments, over the last several years John has led its transformation and restructuring team driving operational turnarounds, strategy formulation/implementation, tuck-in M&A, and general operational excellence for Red Apple’s new acquisitions and wholly-owned businesses.
</br></br>
"John has developed strong experience in nearly every division of the company over the last dozen years which leaves him well suited to the role. Together, I look forward to John continuing the growth of the company into the next generation,” stated John Catsimatidis Sr.
</br></br>
<b>Strategic Growth – Multigenerational Vision</b>
</br></br>
In his statement, John A. Catsimatidis Jr observed, "I am honored to step into the role of President and COO of Red Apple Group. The business was started with one grocery store and has grown to what it is today with over $7 billion of revenue, a testament to a successful strategy built on integrity, vision, and an extraordinary work ethic. I am thrilled to play a leadership role to make sure that growth continues for decades to come.”
</br></br>
John will be responsible for overseeing the company’s day-to-day operations while also steering long-term strategic initiatives.
</br></br>
<b>About Red Apple Group:</b>
</br></br>
Red Apple Group, founded in 1968, is a New York-based conglomerate that owns and operates assets in the energy, real estate, logistics, finance, insurance, media and supermarket
industries, including companies such as United Refining Company, United Metro Energy, Red
Apple Real Estate and various entities related to it, Red Apple Investments, Red Apple Media,
and Gristedes and D’Agostino Supermarkets.
</br>
<hr>
<em>March 14, 2023</em></br>
### United Refining Company/Kwik Fill named to Forbes list
United Refining Company, to include Kwik Fill, has been awarded one of America’s Best Mid-Size Employers by Forbes for the year 2023.
</br></br>
`

